import React from "react";

import { Link } from "@at/design-system-elements";
import { TypeFiesta } from "@at/design-system-foundation";

import * as Styles from "../leasing-modal-hub.styled";

export const LeasingFreeReturnsModal = () => {
  return (
    <>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          Free 30-day returns
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          You can return your lease vehicle any time up to 30 days after it has
          been delivered and get your money back.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          We&apos;ll even collect it from your home address, free of charge.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalInfoBlock>
          <Styles.LeasingProductModalParagraph>
            <TypeFiesta weight="600" as="span">
              Good to know:
            </TypeFiesta>{" "}
            You can only return your lease vehicle for free if it has no damage,
            and if it has been driven less than 50 miles.
          </Styles.LeasingProductModalParagraph>
        </Styles.LeasingProductModalInfoBlock>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalParagraph>
          That&apos;s all the important stuff. But, if you&apos;d like to know
          more, read our{" "}
          <Link
            href="https://www.autotrader.co.uk/terms-and-conditions/vanarama"
            routerLink={false}
            attributes={{
              target: "_blank",
            }}
          >
            Terms and Conditions
          </Link>{" "}
          for the legal bits.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
    </>
  );
};
